module.exports = __webpack_public_path__ + "img/icon_home_sb.703ea3e9.png";